var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "#374DA0",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6591 5.81836C9.10287 5.81836 5.40912 9.51211 5.40912 14.0684C5.40912 18.6246 9.10287 22.3184 13.6591 22.3184C18.2154 22.3184 21.9091 18.6246 21.9091 14.0684C21.9091 9.51211 18.2154 5.81836 13.6591 5.81836ZM14.4091 17.0684C14.4091 17.2673 14.3301 17.458 14.1894 17.5987C14.0488 17.7393 13.858 17.8184 13.6591 17.8184C13.4602 17.8184 13.2694 17.7393 13.1288 17.5987C12.9881 17.458 12.9091 17.2673 12.9091 17.0684V14.8184H10.6591C10.4602 14.8184 10.2694 14.7393 10.1288 14.5987C9.98814 14.458 9.90912 14.2673 9.90912 14.0684C9.90912 13.8694 9.98814 13.6787 10.1288 13.538C10.2694 13.3974 10.4602 13.3184 10.6591 13.3184H12.9091V11.0684C12.9091 10.8694 12.9881 10.6787 13.1288 10.538C13.2694 10.3974 13.4602 10.3184 13.6591 10.3184C13.858 10.3184 14.0488 10.3974 14.1894 10.538C14.3301 10.6787 14.4091 10.8694 14.4091 11.0684V13.3184H16.6591C16.858 13.3184 17.0488 13.3974 17.1894 13.538C17.3301 13.6787 17.4091 13.8694 17.4091 14.0684C17.4091 14.2673 17.3301 14.458 17.1894 14.5987C17.0488 14.7393 16.858 14.8184 16.6591 14.8184H14.4091V17.0684Z",
    fill: "#374DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopupIcon);
export default __webpack_public_path__ + "static/media/TopupIcon.58a836ef23ae6b3074540d32fbf9174e.svg";
export { ForwardRef as ReactComponent };